import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// Connects to data-controller="select-navigate"
// Navigates to the selected <option>'s value (a URL) on change.
export default class extends Controller {
  navigate(event) {
    const url = event.target.value;
    if (url) Turbo.visit(url);
  }
}
